import React, { useRef, useState, useEffect } from "react";
import { Row, Col, Container, Button, Form } from "react-bootstrap";
import Formsy from "formsy-react";
import TextField from "../components/bootstrap/input";
import { fetch, localStorage, window } from "window-or-global";
import { useAsyncSetState } from "use-async-setstate";
import { useQueryParam, StringParam } from "use-query-params";
import Terms from "../components/portal/terms";
import PrivacyPolicy from "../components/portal/privacy-policy";
import { sleep } from "../utils";

export default function LoginControl(props) {
  let dst;
  const {
    authUrl, 
    portalUrl, 
    apiUrl, 
    setShowMfa, 
    setAllowedOptions, 
    setUserData, 
    setMfa
  } = props;
  const formRef = useRef(null);
  const [isChecked, setIsChecked] = useState(false);
  const [passwordShow, setPasswordShow] = useState(false);
  const [processing, setProcessing] = useAsyncSetState(false);
  const [loginError, setLoginError] = useAsyncSetState(false);
  const [authDetails, setAuthDetails] = useAsyncSetState(false);
  const [showTerm, setTerm] = useAsyncSetState(false);
  const [showPolicy, setPolicy] = useAsyncSetState(false);

  const handleValidLoginSubmit = async (data) => {
    setProcessing(true);
    try {
      const response = await fetch(`${apiUrl}rest.api/login`, {
        headers: {
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({ ...data }),
      });

      if (response.status === 503) {
        setProcessing(false);
        setLoginError("Something went wrong");
        return;
      }

      const parsedResponse = await response.json();

      if (parsedResponse?.success === "Invalid username/password") {
        setProcessing(false);
        setLoginError("Invalid username and/or password.");
      }

      if (response.status === 401) {
        setProcessing(false);
        setLoginError(parsedResponse.error);
      }

      if (
        parsedResponse.success && 
        parsedResponse.user && 
        !parsedResponse.jwtToken
      ) {
        await setMfa({
          user: parsedResponse.user, 
          hasUserTOTP: parsedResponse.hasUserTOTP, 
          loginDetails: data,
        });
        if (parsedResponse.user.mobileNumber) {
          setAllowedOptions((prev) => [...prev, "sms"]);
        }

        if (parsedResponse.user.email) {
          setAllowedOptions((prev) => [...prev, "email"]);
        }

        if (parsedResponse.hasUserTOTP) {
          setAllowedOptions((prev) => [...prev, "user-totp"]);
        }

        setUserData(parsedResponse.user);

        await setShowMfa(true);
        return;
      } else {
        if (parsedResponse.jwtToken) {
          localStorage.setItem("authToken", parsedResponse.jwtToken);
        }

        if (parsedResponse.user.id) {
          setAuthDetails(data);
          if (authUrl && authUrl !== "") {
            await sleep();
            formRef.current.submit();
          } else {
            window.location.href = portalUrl;
          }
        }
      }
    } catch (err) {
      console.log("login error", err);
      setProcessing(false);
      setLoginError("Invalid username and/or password.");
    }

    setProcessing(false);
  };

  const togglePassword = () => {
    if (!passwordShow) {
      setPasswordShow(true);
    } else {
      setPasswordShow(false);
    }
  };

  const checkBoxComponent = () => {
    const tickCheckBox = () => {
      setIsChecked((prev) => !prev);
    };

    useEffect(() => {
      const dataType = typeof isChecked;
      if (dataType === "boolean") {
        localStorage.setItem("keepUserLogged", JSON.stringify(isChecked));
      } else {
        window.alert("action not allowed");
      }
    }, [isChecked]);

    return (
      <div style={{width: "140px"}}>
        <Form.Check>
          <Form.Check.Input
            type="checkbox"
            className="vw-login-check-remember"
            onChange={() => tickCheckBox()}
            checked={isChecked}
          />
          <Form.Check.Label
            for="login-check-remember"
            className="vw-login-label-remember"
          >
            {"Keep me login"}
          </Form.Check.Label>
        </Form.Check>
      </div>
    );
  };

  const forgotPasswordComponent = () => {
    return (
      <div className="vw-forgot-password">
        <a className="vw-forgot-password-text" href="/forgot-password">
          {"Forgot Password?"}
        </a>
      </div>
    );
  };

  return (
    <>
      {showTerm && <Terms onClose={() => setTerm(false)} />}
      {showPolicy && <PrivacyPolicy onClose={() => setPolicy(false)} />}
      <form ref={formRef} name="login" action={authUrl} method="post">
        <input type="hidden" value="hotspot" name="radius11" />
        <input type="hidden" name="dst" value={`${dst || portalUrl}`} />
        <input 
          type="hidden" 
          name="username" 
          value={(authDetails?.userName || "").toLowerCase()}
        />
        <input type="hidden" name="password" value={authDetails?.password} />
      </form>
      <Formsy
        className="vw-section-panel"
        onValidSubmit={handleValidLoginSubmit}
        disabled={processing}
      >
        <Container fluid>
          <Row>
            <Col xs={12} className="vw-login-field">
              <TextField
                label={"Username"}
                hideRequiredMark
                name="userName"
                autoComplete="off"
                outlined
                id="username-field"
                disabled={processing}
                suffix={<i className="fas fa-user-tie username-icon" />}
                required
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} className="vw-login-field">
              <TextField
                label={"Password"}
                name="password"
                id="password-field"
                hideRequiredMark
                outlined
                autoComplete="off"
                type={passwordShow ? "text" : "password"}
                disabled={processing}
                suffix={
                  <i className={passwordShow ? "fas fa-eye pass-icon" : "fas fa-eye-slash pass-icon"} onClick={() => setPasswordShow(!passwordShow)}/>
                }
                required
              />
            </Col>
          </Row>
          <div className="vw-login-remember">
            {checkBoxComponent()}
            {forgotPasswordComponent()}
          </div>
          <div className="vw-login-buttons">
            <Button
              variant="login"
              className="vw-login-button"
              type="submit"
              disabled={processing}
            >
              {"Login"}
            </Button>
            {loginError && (
              <div className="alert alert-danger login-error">
                <i
                  className="fas fa-exclamation-circle"
                />
                {loginError}
              </div>
            )}
            <div className="signup-container">
              <span className="signup-label">{"Don't have an account?"}&#160;</span>
              <a href="/register" className="signup-link">
                {" Sign Up"}
              </a>
            </div>
          </div>
        </Container>
      </Formsy>
    </>
  );
}
